import { Platform, StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import TransactionsList from '@/components/paymentMethods/TransactionsList';
import DownloadTransactionsButton from '@/components/buttons/DownloadTransactionsButton';
import Text from '@/components/Text';
import PlatformContainer from '@/components/web/PlatformContainer';
import { useColor } from '@/hooks/useColor';
import { i18n } from '@/utils/i18n';

const TransactionsNpo = () => {
  const colors = useColor();

  return (
    <PlatformContainer
      contentCustomClassnames="h-screen"
      containerCustomClassname="overscroll-contain"
      overflowY={false}>
      <SafeAreaView style={styles.flexOne} edges={Platform.OS === 'ios' ? ['top'] : []}>
        <View style={styles.header}>
          <View style={styles.screenTitleContainer}>
            <Text numberOfLines={1} ellipsizeMode="tail" style={[styles.screenTitle, { color: colors.titleText }]}>
              {i18n.t('bottom_tab.transactions')}
            </Text>
          </View>

          <View style={styles.side} />

          <View style={styles.side}>
            <View style={styles.zIndex}>
              <DownloadTransactionsButton tintColor="black" />
            </View>
          </View>
        </View>

        <TransactionsList amountColor="green" isNpo />
      </SafeAreaView>
    </PlatformContainer>
  );
};

const styles = StyleSheet.create({
  flexOne: {
    flex: 1
  },

  header: {
    width: '100%',
    height: 44,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginVertical: 10,
    paddingHorizontal: 18,
    zIndex: 10,
    elevation: 10
  },

  screenTitleContainer: {
    position: 'absolute',
    left: 0,
    right: 0,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: -1
  },

  screenTitle: {
    flex: 1,
    textTransform: 'capitalize',
    fontWeight: '700',
    fontSize: 20,
    textAlign: 'center'
  },

  side: {
    flex: 1,
    alignItems: 'flex-end',
    justifyContent: 'center',
    zIndex: 20
  },

  zIndex: {
    zIndex: 99
  }
});

export default TransactionsNpo;
